import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalserviceproviderinpune() {



  const cardData =
  {
    keyword: ' Corporate Car Rental Service Provider in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rental Service Provider in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited is a leading Corporate Car Rental Service Provider in Pune, offering professional and dependable transportation solutions for businesses, IT parks, manufacturing units, and corporate offices across the city. Our fleet of executive sedans, SUVs, and premium cars ensures comfortable, safe, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, client visits, inter-office travel, or corporate events, we deliver seamless and hassle-free mobility services. With trained chauffeurs, flexible rental packages, transparent billing, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and reliable corporate travel experience for businesses operating in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Corporate Fleet Provider Pune",
"description": "Corporate Fleet Provider Pune offers end-to-end fleet management solutions for businesses, providing dedicated sedans, SUVs, and staff cabs for daily employee commuting, client visits, and corporate travel. The service includes route planning, driver management, GPS tracking, and maintenance support to ensure smooth, punctual, and safe operations for corporate mobility across Pune."
},
{
"name": "Business Car Lease Pune",
"description": "Business Car Lease Pune delivers flexible car leasing solutions for companies, allowing long-term access to sedans, SUVs, and executive vehicles without the burden of ownership. The service includes maintenance, insurance, and driver support, enabling organizations to manage employee transportation efficiently while reducing operational costs."
},
{
"name": "Staff Car Rental Pune",
"description": "Staff Car Rental Pune specializes in daily and monthly car rental services for corporate staff. With well-maintained vehicles, trained drivers, and structured routes, the service ensures safe, punctual, and comfortable commutes for employees across offices, industrial areas, and IT parks in Pune."
},
{
"name": "Chauffeur Driven Cars Pune",
"description": "Chauffeur Driven Cars Pune provides premium, professional driver services for executives, managers, and corporate clients. The service emphasizes safety, punctuality, and discretion, offering well-maintained sedans, SUVs, and luxury vehicles for office commutes, business meetings, and outstation travel across Pune."
},
{
"name": "Employee Travel Car Hire Pune",
"description": "Employee Travel Car Hire Pune offers tailored car rental services for corporate employee transportation. The service ensures timely pickups, comfortable rides, trained drivers, and GPS-monitored vehicles, facilitating efficient workforce mobility for daily commutes, client visits, and corporate events."
},
{
"name": "Company Car Rental Pune",
"description": "Company Car Rental Pune provides reliable corporate car rental services with a focus on employee commuting, executive travel, and inter-office transportation. The service features structured routes, professional drivers, and well-maintained vehicles to ensure safe, comfortable, and punctual travel for businesses of all sizes."
},
{
"name": "Office Commute Cars Pune",
"description": "Office Commute Cars Pune delivers dependable transportation solutions for daily office commuting. With GPS-enabled vehicles, trained drivers, and optimized routes, the service ensures employees reach workplaces on time, reduces commuting stress, and enhances productivity for organizations in Pune."
},
{
"name": "Monthly Corporate Car Rental Pune",
"description": "Monthly Corporate Car Rental Pune offers long-term vehicle rental plans for companies requiring consistent employee transportation. The service includes dedicated sedans, SUVs, and staff cabs, structured routes, and multi-shift scheduling, ensuring reliable, safe, and efficient commuting for large workforce operations."
},
{
"name": "Best Car Rental for Companies Pune",
"description": "Best Car Rental for Companies Pune provides premium corporate transportation services with a focus on reliability, comfort, and professional service. The fleet includes sedans, SUVs, and executive cars with trained drivers, GPS tracking, and flexible scheduling to meet the unique mobility needs of businesses in Pune."
},
{
"name": "Executive Car Rental Pune",
"description": "Executive Car Rental Pune delivers high-end, chauffeur-driven sedans and SUVs for executives, managers, and corporate visitors. The service ensures professional drivers, punctual pickups, luxury vehicles, and a comfortable commuting experience suitable for business meetings, client visits, and corporate travel."
},
{
"name": "Premium Corporate Car Service Pune",
"description": "Premium Corporate Car Service Pune provides top-tier corporate transportation solutions, combining luxury vehicles, trained chauffeurs, GPS tracking, and structured routes. The service ensures executive comfort, safety, and reliability for daily commuting, business trips, and client meetings across Pune."
},
{
"name": "Outstation Corporate Cars Pune",
"description": "Outstation Corporate Cars Pune offers safe and comfortable long-distance travel for corporate employees, clients, and executives. The service provides well-maintained sedans and SUVs with professional drivers, timely departures, and optimized routes for intercity and outstation business travel."
},
{
"name": "Sedan Car Hire Pune",
"description": "Sedan Car Hire Pune provides premium and mid-range sedans for corporate and individual use. The service includes professional drivers, GPS-enabled vehicles, and structured commuting routes, ensuring safe, punctual, and comfortable travel for employees, managers, and clients."
},
{
"name": "SUV Car Hire Pune",
"description": "SUV Car Hire Pune offers spacious and comfortable SUVs for corporate team travel, employee commuting, and long-distance trips. The service emphasizes safety, reliability, professional drivers, and well-maintained vehicles to meet the mobility needs of businesses and large teams in Pune."
},
{
"name": "Car Rental Vendor Pune",
"description": "Car Rental Vendor Pune serves as a professional provider of corporate and individual car rental services. Offering a fleet of sedans, SUVs, and executive vehicles with trained drivers and GPS tracking, the service ensures efficient, reliable, and safe transportation for businesses, office staff, and personal travel across Pune."
}
],

"tableData": [
["Corporate Fleet Provider Pune", "Business Car Lease Pune"],
["Staff Car Rental Pune", "Chauffeur Driven Cars Pune"],
["Employee Travel Car Hire Pune", "Company Car Rental Pune"],
["Office Commute Cars Pune", "Monthly Corporate Car Rental Pune"],
["Best Car Rental for Companies Pune", "Executive Car Rental Pune"],
["Premium Corporate Car Service Pune", "Outstation Corporate Cars Pune"],
["Sedan Car Hire Pune", "SUV Car Hire Pune"],
["Car Rental Vendor Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental Service Provider in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited is a trusted corporate car rental service provider in Pune, delivering reliable and professional transportation solutions for businesses."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles",
    "WhyChoosedescription": "We offer a variety of vehicles including sedans, SUVs, tempo travellers, and buses, catering to all corporate travel requirements."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our trained and courteous drivers ensure safe, timely, and comfortable rides for employees, executives, and VIP clients."
  },
  {
    "WhyChooseheading": "Customized Rental Plans",
    "WhyChoosedescription": "We provide flexible corporate car rental packages, including hourly, daily, and monthly options, tailored to suit your business needs."
  },
  {
    "WhyChooseheading": "Reliable & On-Time Service",
    "WhyChoosedescription": "Our services prioritize punctuality and dependability, ensuring seamless corporate travel for meetings, events, and daily commuting."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Clients",
    "WhyChoosedescription": "We offer round-the-clock assistance for bookings, emergencies, and schedule changes, ensuring uninterrupted corporate mobility."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly maintained, sanitized, and equipped with modern safety features to provide secure and comfortable journeys."
  },
  {
    "WhyChooseheading": "Easy Booking & Efficient Coordination",
    "WhyChoosedescription": "Our simple booking process and effective coordination make corporate car rentals smooth, convenient, and hassle-free for businesses."
  }
]





























  }

const faqData = [
  {
    question: 'Is Pune Corporate Cars India Private Limited a corporate car rental service provider in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited is a trusted corporate car rental service provider offering reliable and professional services in Pune.',
  },
  {
    question: 'What services do you offer as a corporate car rental company?',
    answer: 'We provide corporate cab services, employee transportation, airport transfers, outstation travel, and event-specific car rentals.',
  },
  {
    question: 'How can companies book corporate car rental services in Pune?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you offer customized rental plans for corporate clients?',
    answer: 'Yes, we provide tailored car rental solutions based on the company’s size, travel requirements, and frequency.',
  },
  {
    question: 'What types of vehicles are available for corporate car rentals?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate needs.',
  },
  {
    question: 'Can companies avail monthly or annual corporate rental contracts?',
    answer: 'Absolutely. We offer flexible monthly and annual contracts with transparent pricing.',
  },
  {
    question: 'Do you provide airport transfer services for corporate rentals?',
    answer: 'Yes, we provide punctual and professional airport pickup and drop services for corporate clients.',
  },
  {
    question: 'What safety measures are followed for corporate car rentals?',
    answer: 'Our vehicles are GPS-enabled, sanitized regularly, and driven by trained chauffeurs following strict safety standards.',
  },
  {
    question: 'What payment modes are accepted for corporate car rental services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shreyas Kulkarni',
    feedback: 'Pune Corporate Cars India Private Limited has been our preferred corporate car rental partner. Professional, reliable, and timely service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ishita Rane',
    feedback: 'Excellent corporate car rental service in Pune. Their team is highly professional and dependable.',
    rating: 5,
  },
];






















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Service Provider in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-rental-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited is a trusted corporate car rental service provider in Pune, offering chauffeur-driven cars, executive car rentals, monthly corporate car services, and outstation corporate cars. We provide premium sedans, SUVs, and fleet solutions for businesses and corporate offices.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5100", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rental-service-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Car Rental Service Provider in Pune | Executive & Fleet Cars | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited is a trusted corporate car rental service provider in Pune, offering chauffeur-driven cars, executive car rentals, monthly corporate car services, and outstation corporate cars. We provide premium sedans, SUVs, and fleet solutions for businesses and corporate offices."
  />

  <meta
    name="keywords"
    content="Corporate Fleet Provider Pune, Business Car Lease Pune, Staff Car Rental Pune, Chauffeur Driven Cars Pune, Employee Travel Car Hire Pune, Company Car Rental Pune, Office Commute Cars Pune, Monthly Corporate Car Rental Pune, Best Car Rental for Companies Pune, Executive Car Rental Pune, Premium Corporate Car Service Pune, Outstation Corporate Cars Pune, Sedan Car Hire Pune, SUV Car Hire Pune, Car Rental Vendor Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalserviceproviderinpune;